// extracted by mini-css-extract-plugin
module.exports = {"tip-container":"LabelToolTip_tip-container__BGCSl","custom-tooltip":"LabelToolTip_custom-tooltip__9lcLI","custom-tooltip-inner":"LabelToolTip_custom-tooltip-inner__3euSP"};